import type { FetchOptions } from 'ofetch'
import type {
  BuryingPointRequestParams,
  FloorDetailIndexRoundResponse,
  FloorDetailResponse,
  FloorDiscountListResponse,
  FloorEvaluateResponse,
  FloorListDTO,
  FloorListVO,
  FloorLookHouseResponse,
  FloorNewsListParams,
  FloorNewsListResponse,
  LookHouseRequest,
  MapAreaListDTO,
  MapAreaListVO,
  NewHouseFilterResponse,
  NewHouseFooterResponse,
  NewHouseHotSearchResponse,
  NewHouseIndexRequest,
  NewHouseIndexResponse,
  NewsListParams,
  NewsListResponse,
  RandomPhoneAndFloorResponse,
  ResponseFloorHouseVisit,
  SearchRankListParams,
  SearchRankListResponse,
  SimilarFloorRequest,
  TdkRequestParams,
  getSecretNumberType,
} from './interface'
import { useRequest } from '~/composables/useRequest'
import type { PageList, Response } from '~/server/common/interface'
import config from '~/common/config'

const sameUrl = '/newhouse-pc'
const memberUrl = '/member-pc'

// 地图找房
export function getMapAreaList(params: MapAreaListDTO, options?: Omit<FetchOptions, 'url' | 'method'>): Promise<Response<MapAreaListVO[]>> {
  const url = `/floor/index/map-area-list`
  return useRequest().get(`${sameUrl}${url}`, params, options)
}

// 新房楼盘列表
export function getFloorList(params: FloorListDTO, options?: Omit<FetchOptions, 'url' | 'method'>): Promise<Response<PageList<FloorListVO>>> {
  const url = `/floor/index/query-by-page`
  return useRequest().get(`${sameUrl}${url}`, params, options)
}
// 新房楼盘列表
export function getFloorSimpleList(params: FloorListDTO, options?: Omit<FetchOptions, 'url' | 'method'>): Promise<Response<PageList<FloorListVO>>> {
  const url = `/floor/index/query-by-page-simple`
  return useRequest().get(`${sameUrl}${url}`, params, options)
}

// 新房筛选条件
export function getNewHouseFilter(p: string): NewHouseFilterResponse {
  const url = `/floor/index/search-floor-param`
  return useRequest().get(`${sameUrl}${url}`, { p })
}

// 猜你喜欢非新房列表
export function getFloorMayLike(params: any): Promise<any> {
  const url = `/floor/index/guess-you-like-order`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 楼盘首页-周边楼盘 /floor/index/floor-detail-index-round-floor
export function getFloorDetailIndexRoundFloor(params: any) {
  const url = `/floor/index/floor-detail-index-round-floor`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 猜你喜欢新房列表
export function getFloorMayLikeNewHouse(params: any): Promise<any> {
  const url = `/floor/index/guess-you-like-random`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 新房分页查询
export function getNewHouseList(params: NewHouseIndexRequest, signal: AbortSignal | null = null): NewHouseIndexResponse {
  const url = `/floor/index/search-floor-page`
  return useRequest().get(`${sameUrl}${url}`, params, {
    signal,
  })
}
// 楼盘评测
export async function getFloorEvaluate(params: { cityId: number, floorId: number }): FloorEvaluateResponse {
  const url = `/floor/floor-evaluate/detail-by-floorid`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 户型详情
export function getHouseModelDetails(params: any): Promise<any> {
  const url = `/floor/house-model/details`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 户型下拉
export function getHouseModelTypeSelect(params: any): Promise<any> {
  const url = `/floor/house-model/model-type-select`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 户型列表
export function getHouseModelPageList(params: any): Promise<any> {
  const url = `/floor/house-model/page-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 户型简单信息，即时通讯使用
export function getHouseModelGetByChat(params: any): Promise<any> {
  const url = `/floor/house-model/get-by-chat`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 楼盘简单信息，即时通讯使用
export function getFloorByChat(params: any): Promise<any> {
  const url = `/floor/index/get-floor-by-chat`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 相似楼盘推荐
export function getSimilarRecommend(params: SimilarFloorRequest): NewHouseIndexResponse {
  const url = `/floor/index/similar-recommend`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 新房热门搜索
export function getHotSearch(cityId: number): NewHouseHotSearchResponse {
  const url = `/floor/index/hot-search`
  return useRequest().get(`${sameUrl}${url}`, { cityId })
}

// 电话咨询（隐私号小程序二维码）
// export function getSecretFloorNumberMiniProgram(params: MiniFloorNumberRequest): Promise<any> {
//   const url = `/floor/index/secret-floor-number-mini-program`
//   return useRequest().get(`${sameUrl}${url}`, params, {
//     responseType: 'blob',
//   })
// }
// // 周边配套
// export async function getFloorCityRoundPage(params: MapParams): FloorMapAroundResponse {
//   const url = `/floor/city-round/page`
//   return useRequest().get(`${sameUrl}${url}`, params)
// }

// 品牌列表
export function getBrandList(params: any): Promise<Response> {
  const url = `/floor/index/company-brand-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 品牌详情
export function getBrandDetail(params: any): Promise<Response> {
  const url = `/floor/index/company-brand-details`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 新房分页查询
export function getNewHouseListByParam(params: any): Promise<any> {
  const url = `/floor/index/query-by-page`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 主题找房，新房分页查询
export function getNewHouseListByTheme(params: any): Promise<any> {
  const url = `/floor/index/theme-find-house`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 根据城市和tab（榜单配置id）分页查询
export function getRankingList(params: any): Promise<any> {
  const url = `/floor/rank-list/page`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 新房分页查询
export async function getNewHouseQueryByPage(params: any) {
  const url = `/floor/index/query-by-page`
  return useRequest().get(`${sameUrl}${url}`, params)
}
//  区域下拉+板块下拉
export async function getAreaAndChildList(params: any) {
  const url = `/floor/index/floor-area-zone-param`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 楼盘相册-详细信息 /floor/photo/detail
export async function getFloorPhotoDetail(params: any) {
  const url = `/floor/photo/detail`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// /floor/index/details
export async function getFloorDetails(params: any) {
  const url = `/floor/index/details`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 电话咨询（隐私号）
export async function getSecretNumber(params: getSecretNumberType) {
  const url = `/floor/index/secret-number`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 楼盘首页
export function getFloorDetailIndex(params: { cityId: number, floorId: number }): FloorDetailResponse {
  const url = '/floor/index/floor-detail-index'
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 楼盘首页-周边配套
export function getFloorDetailIndexRound(params: { cityId: number, floorId: number }): FloorDetailIndexRoundResponse {
  const url = '/floor/index/floor-detail-index-round'
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 一房一价--基本信息
export function getBuildingBaseInfo(params: { cityId: number, floorId: number }) {
  const url = `/floor/building/base-info`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 房源列表（视图模式）
export async function getHousePageViewList(params: any) {
  const url = `/floor/house/page-view-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 房源列表（列表模式）
export async function getHousePageList(params: any) {
  const url = `/floor/house/page-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 房源详情
export async function getHouseDetails(params: any) {
  const url = `/floor/house/details`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 看房团列表
export function getLookHouse(params: LookHouseRequest): FloorLookHouseResponse {
  const url = `/floor/house-visit/page`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 看房团详情
export function getLookHouseDetail(params: any): ResponseFloorHouseVisit {
  const url = `/floor/house-visit/detail`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 看房团列表
export function getRandomPhoneAndFloor(params: any): RandomPhoneAndFloorResponse {
  const url = `/floor/house-visit/random-phone-and-floor`
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 报名
export function signupNow(params: any): Promise<any> {
  const url = `/floor/house-visit/signup-now`
  return useRequest().post(`${sameUrl}${url}`, params)
}

// 广告列表 ad/query-by-page
export async function getAdList(params: any) {
  const url = `/ad/query-by-page`
  return useRequest().get(`${memberUrl}${url}`, params)
}

// 房价分析-详情
export async function getFloorPriceDetail(params: any) {
  const url = `/floor/price/detail`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 楼盘动态列表
export function getFloorNewsList(params: FloorNewsListParams): FloorNewsListResponse {
  const url = `/floor/news/page-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

// 楼盘资讯列表 - api4
export function getFloorInfoList(params: NewsListParams): NewsListResponse {
  const url = `${config.API_HOST}/news/api/news/floor`
  return useRequest().get(`${url}`, params)
}

// 收藏
export async function saveFavorite(params: any) {
  const url = `/users/favorite/save-favorite`
  return useRequest().post(`${memberUrl}${url}`, params)
}

// 取消收藏
export async function cancelFavorite(params: any) {
  const url = `/users/favorite/cancel-favorite`
  return useRequest().post(`${memberUrl}${url}`, params)
}

// 检查是否收藏
export async function checkFavorite(params: any) {
  const url = `/users/favorite/check`
  return useRequest().get(`${memberUrl}${url}`, params)
}

/**
 * 楼盘优惠信息
 */
export function getFloorDiscountList(params: { cityId: number, floorId: number }): FloorDiscountListResponse {
  const url = `/floor/discount/list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

/**
 * 根据城市展示 热门楼盘推荐
 */
export function getHotSearchFloor(params: SearchRankListParams): SearchRankListResponse {
  const url = '/floor/rank-list/search-hot-page'
  return useRequest().get(`${sameUrl}${url}`, params)
}

/**
 * 新房TDK
 */
export function getFooterTdk(params: TdkRequestParams): NewHouseFooterResponse {
  const url = '/footer/tdk'
  return useRequest().get(`${sameUrl}${url}`, params)
}
// 埋点统计 新房搜索和点击事件
export async function saveBuryingPoint(params: BuryingPointRequestParams) {
  const url = `/floor/burying-point/save`
  return useRequest().post(`${sameUrl}${url}`, params)
}

/**
 * 楼盘首页等页面开关，tab标签有无数据查询接口
 * path:/floor/index/floor-tab-switch
 */
export function getFloorTabSwitch(params: any) {
  const url = `/floor/index/floor-tab-switch`
  return useRequest().get(`${sameUrl}${url}`, params)
}

/**
 * 新房列表的菜单配置查询
 * path:/floor/index/floor-menu-config-list
 */
export function getFloorMenuConfigList(params: any) {
  const url = `/floor/index/floor-menu-config-list`
  return useRequest().get(`${sameUrl}${url}`, params)
}

/**
 * 页面顶部菜单获取
 */
export function getHeadMenuList(params: any) {
  const url = `/glb/menu/headMenuList`
  return useRequest().get(`${memberUrl}${url}`, params)
}
